module.exports = __webpack_public_path__ + "img/journal-icon.2052a6d9.svg";